import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="bg-background-100">
      <div className="px-4 md:px-6 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-10 md:mb-14">
          <div className="lg:w-1/3">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              {t("categories.title")}
            </h2>
          </div>
          <div className="lg:w-2/3">
            <p className="text-foreground-500 text-sm md:text-base leading-relaxed">
              {t("categories.subtitle")} — {t("hero.subtitle")}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <a
              key={cat.nameKey}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-5 md:p-6 rounded-lg bg-background-50 hover:bg-background-200/50 transition-all duration-200 cursor-pointer border border-background-200/50 hover:border-primary-200/50"
            >
              <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-background-100 group-hover:bg-primary-50 transition-colors">
                <i className="ri-shopping-bag-line text-xl md:text-2xl text-foreground-500 group-hover:text-primary-500 transition-colors"></i>
              </span>
              <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors text-center whitespace-nowrap">
                {t(cat.nameKey)}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}